import * as ActionTypes from './types.action';

export const getHalalBestSellers = (itemIds, branch) => ({
  type: ActionTypes.GET_HALAL_BEST_SELLERS_REQUESTED,
  itemIds,
  branch,
});
